import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { Checkbox } from "../../../../../../../common-deprecated/styles/v2/toyota/components/Form";

export const Wrapper = styled.div<{ hasBorder?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-top: ${({ hasBorder }) => (hasBorder ? `1px solid ${theme.colors.grey2}` : "none")};

    &:only-child {
        padding-top: 0;
        border-top: 0;
    }
    ${Checkbox} {
        label {
            font-size: 1.6rem;
        }
    }
`;
